// extracted by mini-css-extract-plugin
export default {"card":"styles_card__aMJVy","table":"styles_table__47TZ8"};